'use client'

import { FC, useState } from 'react'

import { ITabsProps } from './types'

const Tabs: FC<ITabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <div>
      <div className="flex border-b border-grayscale-200 border-gray-200">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className="relative px-4 py-2 -mb-px prose-headline-h6 text-primary-900"
          >
            {tab.title}
            <span
              className={`absolute bottom-0 left-0 h-[3px] bg-tertiary-300 transition-width ease-in-out duration-200 ${activeTab === index ? 'w-full' : 'w-0'}`}
            />
          </button>
        ))}
      </div>
      <div className="p-4">{tabs[activeTab].children}</div>
    </div>
  )
}

export default Tabs
